import { render, staticRenderFns } from "./PortcallberthsGrid.vue?vue&type=template&id=df545680"
import script from "./PortcallberthsGrid.vue?vue&type=script&lang=js"
export * from "./PortcallberthsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports